export function FloatingWA() {
  return `
    <a 
      href="https://wa.me/6283872687465?text=Halo%20saya%20ingin%20konsultasi%20jasa%20Hunter%20Cuan" 
      class="floating-wa" 
      target="_blank"
      aria-label="Chat on WhatsApp"
    >
      <i class="bi bi-whatsapp"></i>
    </a>
  `;
}
